const STORAGE_KEY = "MSALConfig";

export function getMSALConfig() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveMSALConfig(config) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(config));
}

export function clearMSALConfig() {
  localStorage.removeItem(STORAGE_KEY);
}

export function getAllowedDomain() {
  const config = getMSALConfig();
  if (config?.allowedDomain) return config.allowedDomain.toLowerCase();

  const adminEmail =
    localStorage.getItem("adminEmail") ||
    localStorage.getItem("empEmail") ||
    "";

  if (adminEmail.includes("@")) {
    return adminEmail.split("@")[1].toLowerCase();
  }
  return null;
}

export function buildMicrosoftLoginURL() {
  const config = getMSALConfig();
  if (!config) {
    throw new Error(
      "MSAL configuration not found. " +
        "Please ask your Administrator to configure Azure AD credentials " +
        "under Application Config → General Configuration → Credentials.",
    );
  }

  const { clientId, authority, redirectUri } = config;

  const tenantId = authority.split("/").pop();

  const nonce = _generateNonce();
  const state = _generateState();

  const params = new URLSearchParams({
    client_id: clientId,
    response_type: "id_token",
    response_mode: "fragment",
    scope: "openid profile email User.Read",
    redirect_uri: redirectUri,
    nonce,
    state,
    prompt: "select_account",
  });

  return `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?${params.toString()}`;
}

function _generateNonce() {
  const nonce = crypto.randomUUID();
  sessionStorage.setItem("msal_nonce", nonce);
  return nonce;
}

function _generateState() {
  const state = crypto.randomUUID();
  sessionStorage.setItem("msal_state", state);
  return state;
}
